//https://glidejs.com/

import {onClick} from '../abstract/helpers.js';
import Glide from '@glidejs/glide'

export class GlideSlider {
  constructor(name, options) {
    if(document.querySelector(name)) {

        new Glide(name, options).mount();
    }
  }
}
